import { render, staticRenderFns } from "./EditarPlan.vue?vue&type=template&id=3c6c6f52"
import script from "./EditarPlan.vue?vue&type=script&lang=js"
export * from "./EditarPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports